import { AppState } from 'store/types';

function selectOAuthState(state: AppState) {
  return state.oAuth;
}

export function selectFromOAuth(state: AppState): boolean {
  return selectOAuthState(state).fromOAuth;
}
